export const environment = {
  production: false,
  API_GOOGLE: "AIzaSyCoRb2AD9QvtUWtJ3JNgrB85bwFIi2KeCE",
  DOMAIN_URL: "https://openfiber-backend-api-73-review34.mashfrogcloud.com",
  MAIN_URL: "https://of-wp-jb-dev.mashfrog.com/",
  IFRAME_PARENT:
    "https://openfiber-it--newdev2.sandbox.my.site.com/OFPortaleOperatori",
  translate: false,
  ASSETS_VERSION: 1,
  LOCAL: false,
  path_imgs_markers: "./assets/imgs/markers",
};
